// Soft UI Dashboard PRO React base styles
import colors from "src/assets/theme/base/colors";
import boxShadows from "src/assets/theme/base/boxShadows";
import borders from "src/assets/theme/base/borders";

const { transparent } = colors;
const { lg } = boxShadows;
const { borderRadius } = borders;

const popover = {
  styleOverrides: {
    paper: {
      backgroundColor: transparent.main,
      boxShadow: lg,
      borderRadius: borderRadius.xl,
      overflow: "visible"
    },
  },
};

export default popover;
